import { ShieldCheck, CheckCircle2, Clock } from "lucide-react";

const LEGAL_CONTENT = {
  "mentions-legales": {
    title: "Mentions légales",
    blocks: [
      {
        h: "Éditeur du site",
        p: [
          "Le présent site est édité par EDL-EXPRESS, entreprise d'états des lieux immobiliers d'entrée et de sortie.",
          "Forme juridique : auto-entrepreneur (micro-entreprise)\nSIRET : 99128147800016\nAdresse de référence : 282 route de Genas, 69500 Bron, France\nTéléphone : +33 6 22 85 76 87\nEmail : contact@edl-express.fr\nResponsable de la publication : le dirigeant d'EDL-EXPRESS",
        ],
      },
      {
        h: "Hébergement du site",
        p: [
          "Le site est hébergé par IONOS — Hébergement Web Plus (compte client n° 300409123).",
          "IONOS SAS, 7 place de la Gare, BP 70109, 57201 Sarreguemines Cedex, France — 09 69 32 17 32 — www.ionos.fr.",
        ],
      },
      {
        h: "Propriété intellectuelle",
        p: [
          "L'ensemble des contenus du site (textes, structure, logo, éléments graphiques) est la propriété exclusive d'EDL-EXPRESS, sauf mention contraire. Toute reproduction, même partielle, sans autorisation écrite préalable est interdite.",
          "Les rapports d'état des lieux produits par EDL-EXPRESS restent la propriété du client destinataire, EDL-EXPRESS conservant un droit d'archivage de ses propres documents.",
        ],
      },
      {
        h: "Photographies et marques",
        p: [
          "Les photographies présentées sur ce site sont des visuels d'illustration. « ImmoPad » est un logiciel professionnel appartenant à ses éditeurs respectifs ; EDL-EXPRESS est utilisateur de la solution.",
        ],
      },
      {
        h: "Responsabilité",
        p: [
          "EDL-EXPRESS s'efforce d'assurer l'exactitude des informations diffusées sur ce site. Les tarifs affichés sont des tarifs indicatifs de lancement, susceptibles d'évolution, et ne constituent pas une offre contractuelle ferme.",
        ],
      },
    ],
  },
  "confidentialite": {
    title: "Politique de confidentialité",
    blocks: [
      {
        h: "Responsable du traitement",
        p: [
          "EDL-EXPRESS, joignable à l'adresse contact@edl-express.fr, est responsable des traitement réalisés à partir de ce site.",
        ],
      },
      {
        h: "Données collectées",
        p: [
          "Via le formulaire « Demander une disponibilité » : nom et prénom ou raison sociale, numéro de téléphone, adresse email, type de bien, type d'état des lieux, ville ou code postal, date d'intervention souhaitée et précisions éventuelles sur le logement.",
          "La ville indiquée peut être géocodée automatiquement (coordonnées approximatives) afin d'afficher des points de demande agrégés et anonymes sur la carte d'intervention.",
        ],
      },
      {
        h: "Finalités du traitement",
        p: [
          "Traiter votre demande de rendez-vous, confirmer un créneau d'intervention, vous transmettre une confirmation et assurer le suivi commercial de votre dossier. Aucune prospection commerciale n'est réalisée sans votre accord.",
        ],
      },
      {
        h: "Base légale",
        p: [
          "Le traitement repose sur l'exécution de mesures précontractuelles à votre demande (devis, prise de rendez-vous) et, le cas échéant, sur l'intérêt légitime d'EDL-EXPRESS à assurer le suivi de sa clientèle professionnelle.",
        ],
      },
      {
        h: "Destinataires des données",
        p: [
          "Vos données sont destinées à l'équipe EDL-EXPRESS, ainsi qu'au service d'acheminement des emails de la plateforme d'hébergement du site (envoi technique de la confirmation et de la notification de demande).",
          "Vos données ne sont jamais vendues ni cédées à des tiers à des fins commerciales.",
        ],
      },
      {
        h: "Durée de conservation",
        p: [
          "Les demandes de disponibilité sont conservées 3 ans à compter du dernier contact. Les points affichés sur la carte d'intervention sont agrégés par ville et ne contiennent aucune donnée nominative.",
        ],
      },
      {
        h: "Cookies et stockage local",
        p: [
          "Le site ne dépose aucun cookie publicitaire ni traceur de mesure d'audience. Un stockage local de session (sessionStorage) est utilisé uniquement dans l'espace d'administration pour conserver la connexion de l'administrateur.",
        ],
      },
      {
        h: "Vos droits",
        p: [
          "Conformément au RGPD et à la loi Informatique et Libertés, vous disposez de droits d'accès, de rectification, d'effacement, de limitation, d'opposition et de portabilité sur vos données.",
          "Pour les exercer, écrivez à contact@edl-express.fr. Vous pouvez également introduire une réclamation auprès de la CNIL (cnil.fr).",
        ],
      },
      {
        h: "Sécurité",
        p: [
          "L'accès aux demandes reçues est restreint à un espace d'administration protégé par mot de passe, réservé à l'exploitant du site.",
        ],
      },
    ],
  },
  cgv: {
    title: "Conditions générales de vente",
    blocks: [
      {
        h: "Objet",
        p: [
          "Les présentes conditions régissent les prestations d'états des lieux d'entrée et de sortie de logements (locatif vide ou meublé) réalisées par EDL-EXPRESS pour le compte d'agences immobilières, de propriétaires particuliers, de conciergeries et de gestionnaires locatifs, en région Rhône-Alpes.",
        ],
      },
      {
        h: "Commande et confirmation de disponibilité",
        p: [
          "La commande est passée par téléphone ou via le formulaire du site (adresse, typologie du bien, créneaux souhaités). L'intervention n'est acquise qu'après confirmation explicite de la disponibilité par EDL-EXPRESS.",
        ],
      },
      {
        h: "Tarifs",
        p: [
          "Les prestations sont facturées selon la grille tarifaire affichée sur le site, distinction entre logement vide et logement meublé, par typologie (Studio / T1 à T5, maison ou logement de plus de 110 m² sur devis). Les tarifs sont identiques pour un état des lieux d'entrée ou de sortie.",
          "Offre de lancement « 10 € offerts sur votre premier état des lieux » : valable une seule fois par client, applicable aux états des lieux bénéficiant d'un tarif forfaitaire affiché, valable dans la zone prioritaire avec déplacement inclus, non cumulable avec d'autres offres promotionnelles et non applicable aux prestations sur devis.",
          "Options et suppléments : garage, cave ou annexe simple (+10 €) ; inventaire meublé très détaillé (+20 à +40 €) ; état des lieux de sortie au même endroit le même jour (-30 %) ; intervention urgente sous 24 h (+20 €).",
          "Offre fidélité « entrée + sortie » : -15 % sur l'état des lieux de sortie lorsque l'état des lieux d'entrée et l'état des lieux de sortie du même logement sont réservés auprès d'EDL-EXPRESS. La remise porte uniquement sur l'état des lieux de sortie et s'applique au tarif public en vigueur au moment de sa réalisation.",
          "Déplacement : inclus dans un rayon de 10 km autour du Lycée Professionnel de l'Automobile Émile Béjuit, 282 route de Genas, 69500 Bron. Au-delà de 10 km : +0,80 €/km aller-retour, avec un minimum de 15 €. Au-delà de 35 km : sur devis.",
          "Offres non cumulables : en cas d'éligibilité à plusieurs offres, l'offre la plus avantageuse pour le client est appliquée.",
        ],
      },
      {
        h: "Ajustement des tarifs",
        p: [
          "Les tarifs indicatifs de lancement sont ajustables selon la surface réelle constatée, le niveau d'ameublement, l'accessibilité du logement et la complexité du dossier. Tout ajustement est signalé avant l'intervention.",
          "Pour un état des lieux d'entrée facturé au locataire par un professionnel, la part locataire est plafonnée par la réglementation en vigueur.",
        ],
      },
      {
        h: "Conditions d'intervention",
        p: [
          "Le client s'assure de l'accès au logement (clés, badges, codes) et, autant que possible, de la présence des parties ou de leur mandataire. EDL-EXPRESS réalise le constat de manière contradictoire, avec signatures des parties présentes sur tablette.",
        ],
      },
      {
        h: "Rapport transmis",
        p: [
          "À l'issue de l'intervention, un rapport numérique structuré (photos, observations, relevés de compteurs, signatures) est transmis par email aux parties désignées par le client. EDL-EXPRESS intervient en qualité de tiers neutre.",
        ],
      },
      {
        h: "Modalités de paiement",
        p: [
          "Les prestations EDL-EXPRESS font l'objet d'un devis ou d'une confirmation tarifaire avant intervention.",
          "Le paiement est exigible à réception de la facture, sauf accord particulier écrit entre les parties.",
          "Moyens de paiement acceptés :\n• Virement bancaire\n• Paiement par carte bancaire ou lien de paiement sécurisé, si disponible\n• Espèces uniquement sur accord préalable et dans les limites légales",
          "Pour les clients professionnels, tout retard de paiement pourra entraîner l'application de pénalités de retard calculées au taux légal en vigueur, ainsi qu'une indemnité forfaitaire de recouvrement de 40 €, conformément à la réglementation applicable aux relations entre professionnels.",
          "Pour les clients particuliers, en cas de retard de paiement, EDL-EXPRESS adressera une relance amiable avant toute procédure de recouvrement.",
          "La facture est transmise par e-mail après réalisation de la prestation, sauf accord contraire.",
          "En cas d'annulation tardive moins de 24 heures avant le rendez-vous, ou en cas d'absence du client ou d'impossibilité d'accès au logement, des frais d'annulation ou de déplacement pourront être facturés.",
        ],
        box: {
          title: "Paiement simple et sécurisé",
          lines: [
            "Facture envoyée par e-mail",
            "Virement ou lien de paiement",
            "Conditions spécifiques possibles pour agences et partenaires réguliers",
          ],
        },
      },
      {
        h: "Droit de rétractation",
        p: [
          "Pour les clients consommateurs, un délai de rétractation de 14 jours s'applique aux commandes passées à distance, sauf demande expresse d'exécution de la prestation avant l'expiration du délai ; le cas échéant, le client doit acquitter la prestation réalisée à la demande expresse.",
        ],
      },
      {
        h: "Responsabilité",
        p: [
          "EDL-EXPRESS garantit la sincérité et la traçabilité des constats réalisés (photos horodatées, relevés). Les relevés de compteurs sont indicatifs et ne remplacent pas les relevés des fournisseurs. Sauf faute lourde, la responsabilité d'EDL-EXPRESS est limitée au montant de la prestation concernée.",
        ],
      },
      {
        h: "Médiation de la consommation",
        p: [
          "Conformément aux articles L.612-1 et suivants du Code de la consommation, tout consommateur a le droit de recourir gratuitement à un médiateur de la consommation en vue de la résolution amiable d'un litige l'opposant à un professionnel.",
          "Avant toute saisine du médiateur, le client doit d'abord adresser une réclamation écrite à EDL-EXPRESS à l'adresse suivante : contact@edl-express.fr.",
          "Si aucune solution amiable n'est trouvée, le consommateur pourra saisir le médiateur de la consommation désigné par EDL-EXPRESS.",
        ],
        mediator: {
          title: "Médiateur en cours de désignation",
          lines: [
            "Nom du médiateur : [Nom du médiateur]",
            "Adresse : [Adresse du médiateur]",
            "Site internet : [Site du médiateur]",
          ],
          note: "EDL-EXPRESS complétera ces informations dès l'adhésion effective à un service de médiation de la consommation.",
          after:
            "Cette clause concerne uniquement les clients consommateurs. Les litiges entre professionnels relèvent des juridictions compétentes, sauf accord amiable entre les parties.",
        },
      },
    ],
  },
};

export default function LegalPage() {
  const slug = window.location.pathname.replace(/^\/+|\/+$/g, "");
  const page = LEGAL_CONTENT[slug] || { title: "Page introuvable", blocks: [{ h: "", p: ["Cette page n'existe pas. Retournez à l'accueil du site."] }] };

  return (
    <div className="min-h-screen bg-night text-white">
      <header className="border-b border-white/10 bg-night/85 backdrop-blur-xl">
        <div className="mx-auto flex h-16 max-w-5xl items-center justify-between px-5 md:h-[72px] md:px-8">
          <a href="/" data-testid="legal-home-link" aria-label="Retour au site EDL-EXPRESS">
            <img
              src="/logo.webp"
              alt="EDL-EXPRESS — États des lieux immobiliers"
              className="h-9 w-auto md:h-10"
            />
          </a>
          <a
            href="/"
            className="rounded-full border border-white/15 px-4 py-2 text-sm text-slate-300 transition-colors hover:border-cyan-400/60 hover:text-cyan-300"
          >
            Retour au site
          </a>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-5 py-16 md:px-8">
        <p className="font-mono text-xs font-semibold uppercase tracking-[0.24em] text-cyan-400">
          Informations légales
        </p>
        <h1 data-testid="legal-title" className="mt-4 font-display text-3xl font-bold tracking-tight sm:text-4xl">
          {page.title}
        </h1>
        <p className="mt-3 text-xs text-slate-500">Dernière mise à jour : 1er octobre 2026</p>

        <div className="mt-10 space-y-10">
          {page.blocks.map((b, i) => (
            <section key={i} data-testid={`legal-block-${i}`}>
              {b.h ? (
                <h2 className="font-display text-lg font-bold text-white sm:text-xl">{b.h}</h2>
              ) : null}
              <div className="mt-3 space-y-3">
                {b.p.map((para, j) => (
                  <p key={j} className="whitespace-pre-line text-sm leading-relaxed text-slate-300">
                    {para}
                  </p>
                ))}
              </div>
              {b.box ? (
                <div className="mt-5 rounded-2xl border border-neon/25 bg-neon/5 p-5">
                  <p className="flex items-center gap-2 font-display text-base font-bold text-white">
                    <ShieldCheck className="h-4 w-4 text-neon" />
                    {b.box.title}
                  </p>
                  <ul className="mt-3 space-y-1.5">
                    {b.box.lines.map((l, j) => (
                      <li key={j} className="flex items-start gap-2 text-sm text-slate-300">
                        <CheckCircle2 className="mt-0.5 h-3.5 w-3.5 shrink-0 text-neon" />
                        {l}
                      </li>
                    ))}
                  </ul>
                </div>
              ) : null}
              {b.mediator ? (
                <div className="mt-5 space-y-3">
                  <div className="rounded-2xl border border-cyan-400/25 bg-cyan-400/5 p-5">
                    <p className="flex items-center gap-2 font-display text-base font-bold text-white">
                      <Clock className="h-4 w-4 text-cyan-300" />
                      {b.mediator.title}
                    </p>
                    <ul className="mt-3 space-y-1.5">
                      {b.mediator.lines.map((l, j) => (
                        <li key={j} className="text-sm text-slate-300">
                          {l}
                        </li>
                      ))}
                    </ul>
                    <p className="mt-3 text-xs leading-relaxed text-slate-500">{b.mediator.note}</p>
                  </div>
                  <p className="text-xs leading-relaxed text-slate-500">{b.mediator.after}</p>
                </div>
              ) : null}
            </section>
          ))}
        </div>

        <p className="mt-14 rounded-xl border border-cyan-400/25 bg-cyan-400/5 p-4 text-xs leading-relaxed text-slate-400">
          Les mentions entre crochets [À compléter] restantes sont des champs réservés à
          l'exploitant (modalités de paiement, médiateur de la consommation…). Le SIRET sera
          ajouté dès son attribution. Ce contenu est fourni à titre d'information et ne remplace
          pas un conseil juridique personnalisé.
        </p>
      </main>
    </div>
  );
}
